"use client";
import { FunnelIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React, { ReactNode, useEffect } from "react";

interface MobileFiltersProps {
  children: ReactNode;
}
const MobileFilters = ({ children }: MobileFiltersProps) => {
  const [isFilterOpen, setIsFilterOpen] = React.useState(false);

  useEffect(() => {
    const body = document.querySelector("body");

    if (body) body.style.overflow = isFilterOpen ? "hidden" : "auto";
  }, [isFilterOpen]);

  const toggleFilter = () => {
    setIsFilterOpen((prevState) => !prevState);
  };

  return (
    <div className="lg:hidden">
      <button
        onClick={toggleFilter}
        className="w-12 h-12 border border-[#C0C1C1] rounded-[8px] inline-flex justify-center items-center text-[#444748]"
      >
        <FunnelIcon className="w-6 h-6" />
      </button>
      {isFilterOpen ? (
        <div className="fixed w-full h-screen inset-0 z-50 bg-white overflow-auto">
          {children}
          <button
            className="p-1 z-10 absolute top-[18px] right-3"
            onClick={toggleFilter}
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default MobileFilters;
